import { useCallback } from 'react'

import { useWidgetMutations } from 'modules/desktop/modules/widgets/hooks'
import { normalizeDisplayOrder } from 'modules/desktop/modules/widgets/utils'
import { WidgetKey, WidgetSize } from 'shared/constants/widgets'
import { PersistedWidgetSpec } from 'shared/types/widgets'
import { generateWidgetId } from 'shared/utils/generateWidgetId'

import { isAiArtifactTile } from '../utils/aiTilesPersistence'

/**
 * Called from AgentBridgeManager, outside the SidebarWidgets render tree.
 * It uses the same query-backed optimistic mutation path as sidebar actions.
 */
export const usePinArtifact = () => {
  const { editWidgets } = useWidgetMutations()

  return useCallback(
    (publicId: string, size: WidgetSize = WidgetSize.MEDIUM) => {
      editWidgets(items => {
        const alreadyPinned = items.some(
          item => isAiArtifactTile(item) && item.config.publicId === publicId
        )
        if (alreadyPinned) return null

        const spec: PersistedWidgetSpec = {
          id: generateWidgetId(),
          widgetKey: WidgetKey.AI_ARTIFACT_TILE,
          size,
          displayOrder: items.length + 1,
          isCollapsed: false,
          config: { publicId }
        }

        return {
          nextWidgets: normalizeDisplayOrder([...items, spec]),
          widgetsToSave: [spec]
        }
      })
    },
    [editWidgets]
  )
}
